// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3X_kH","name":"ConsentHeader_name__2x1M0","birthday":"ConsentHeader_birthday__Vde6V","skeleton":"ConsentHeader_skeleton__1dKeZ"};